import Button from '@mui/material/Button';

interface Props {
  canRequestOpportunity: boolean;
  onRequest: () => void;
}

/**
 * Button that triggers the opportunity request flow.
 * Only rendered when canRequestOpportunity is true.
 */
export default function RequestOpportunityButton({ canRequestOpportunity, onRequest }: Props) {
  if (!canRequestOpportunity) return null;

  return (
    <Button variant="outlined" color="primary" size="small" onClick={onRequest}>
      Solicitar oportunidad
    </Button>
  );
}
